import React from 'react';
export function HookSection() {
  return <section className="w-full bg-cream-dark py-16 md:py-24 px-4" data-id="element-55">
      <div className="max-w-3xl mx-auto text-center" data-id="element-56">
        <h2 className="text-3xl md:text-4xl font-bold text-brown-primary mb-8 font-serif italic" data-id="element-57">
          Seamos honestas:
        </h2>

        <div className="space-y-6 text-lg md:text-xl text-brown-secondary leading-relaxed" data-id="element-58">
          <p data-id="element-59">
            Mirar el espejo cada mañana y sentir que "te estás descuidando"
            duele. Ver a influencers con piel de porcelana usando rutinas de
            $5,000 pesos que tú no puedes costear, duele más.
          </p>

          <p className="font-semibold text-brown-primary text-2xl my-8" data-id="element-60">
            Pero aquí está el secreto que nadie te dice:
          </p>

          <p data-id="element-61">
            Tu piel no sabe leer etiquetas de precio. Tu piel solo reconoce
            activos químicos.
          </p>

          <p className="font-serif italic text-rose-gold text-2xl mt-8" data-id="element-62">
            En México, tenemos acceso a joyas de farmacia que son idénticas (o
            superiores) a las marcas francesas de lujo. Solo te falta el MAPA
            para encontrarlas y el ORDEN para usarlas.
          </p>
        </div>

        <div className="mt-12 w-16 h-1 bg-rose-gold/30 mx-auto rounded-full" data-id="element-63"></div>
      </div>
    </section>;
}